import * as yup from 'yup';

export const laundarySchema = yup.object({
  name: yup.string().required('Item name is required'),
  quantity: yup.string().required('Quantity is required'),
  status: yup.string(),
  amount: yup.string().required('Amount is required')
});
